import { adaptGraphData } from './normalize';

const DEFAULT_ENDPOINT = 'https://guji-meta-worker.crazymasya-c88.workers.dev/graph';

export async function fetchGraph(): Promise<unknown> {
  // In dev, go through Vite proxy to avoid CORS issues
  const endpoint = import.meta.env.DEV
    ? '/__graph'
    : (import.meta.env.VITE_GRAPH_ENDPOINT as string | undefined) || DEFAULT_ENDPOINT;
  const res = await fetch(endpoint, {
    method: 'GET',
    headers: {
      'accept': 'application/json'
    }
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Graph fetch failed: ${res.status} ${res.statusText} ${text}`);
  }
  const data = await res.json();
  // Return raw; adapter is applied at use site to surface warnings in dev
  return data;
}

// Simple in-memory cache for session
let cache: any | null = null;
let cacheTime = 0;
const MAX_AGE_MS = 60_000; // 1 minute

export async function fetchGraphCached(): Promise<ReturnType<typeof adaptGraphData>> {
  if (cache && Date.now() - cacheTime < MAX_AGE_MS) return cache;
  const raw = await fetchGraph();
  cache = adaptGraphData(raw);
  cacheTime = Date.now();
  return cache;
}
